export default class TimerScheduleViewModel {
    public CORE_ID: string;
    public attachedDeviceTypeId: number;
    public mondayActive: boolean;
    public tuesdayActive: boolean;
    public wednesdayActive: boolean;
    public thursdayActive: boolean;
    public fridayActive: boolean;
    public saturdayActive: boolean;
    public sundayActive: boolean;
    public repeatActive: boolean;
    public enabledActive: boolean;
    public fromTime: string;
    public toTime: string;
}
